<template>
  <div>
    <!--  activeData.state: 2 展示计算中相关 -->
    <div class="info" v-if="activeData.state === 4">
      <div class="el-icon-error icon"></div>
      <h2>{{ activeData.info.pay_month }} {{ $t('payroll_salary_33') }}</h2>
    </div>
    <!--  activeData.state: 2 展示计算中相关 -->
    <div class="info" v-if="activeData.state === 2">
      <div class="icon-wraing icon"><div class="sp sp-3balls"></div></div>
      <h2>{{ activeData.info.pay_month }} {{ $t('payroll_wage_32') }}</h2>
      <p>{{ $t('payroll_wage_30') }}</p>
    </div>
    <!--  activeData.state: 3 展示计算完成相关 -->
    <div class="info" v-if="activeData.state === 3 || activeData.info.sub_project_status === '3'">
      <div class="el-icon-success icon"></div>
      <h2>{{ activeData.info.pay_month }} {{ $t('payroll_wage_33') }}</h2>
      <div class="info-con">
        <div class="info-con-item">
          <p>{{ $t('payroll_wage_7') }}</p>
          <span>{{ activeData.info.staff_total | ThousandSeparator }}</span>
        </div>
        <div class="info-con-item center">
          <p>{{ $t('383') }}（{{ currency }}）</p>
          <span>{{ activeData.info.pay_total | ThousandSeparator }}</span>
        </div>
        <div class="info-con-item">
          <p>{{ $t('1259') }}{{ currency }}）</p>
          <span>{{ activeData.info.net_pay_total | ThousandSeparator }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <h1>
        <span>{{ $t('payroll_wage_27') }}</span>
        <!-- 更多 -->
      </h1>
      <div class="search">
        <div class="search-left">
          <el-input
            class="search-input"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="requestParams.search_word"
          >
          </el-input>
          <el-button size="small" type="primary" @click="payrollSubStaffList()">{{ $t('69') }}</el-button>
        </div>
        <div class="search-center"></div>
        <div class="search-right">
          <el-button
            size="small"
            style="margin-right: 15px"
            @click="handleExport"
            v-if="$p('menu.payroll.wage.export')"
            >{{ $t('518') }}</el-button
          >
          <el-popover placement="bottom" width="220" trigger="click" class="some">
            <div>
              <div class="some-all">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
                  $t('1005')
                }}</el-checkbox>
                <el-button size="small" type="text" @click="handleReset">{{ $t('work_rule_7') }}</el-button>
              </div>
              <div></div>
              <el-checkbox-group v-model="checkedColumn" @change="handleCheckedCitiesChange">
                <template v-for="item in columnInfo">
                  <el-checkbox
                    class="column-checkbox"
                    :key="item.type"
                    :label="item.type"
                    v-if="item.title !== 'common'"
                  >
                    {{ $t(item.title) }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
            <img slot="reference" src="@/assets/img/icon-some.png" alt="" />
          </el-popover>
        </div>
      </div>
      <!-- 表格数据 -->
      <all-table
        :tableData="tableData.list"
        :tableCloumn="tableCloumns"
        :info="activeData.info"
        :edit="false"
        @sort="handlerSort"
      />
    </div>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="requestParams.page"
      :page-sizes="page.pageSizes"
      :page-size="requestParams.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    />
    <ExportExcelDialog ref="ExportExcelDialog" />
  </div>
</template>

<script>
import { payrollSubStaffList, getListHeaderColumns } from '@/api/payroll'
// 上传
import Pagination from '@/components/pagination'
import allTable from './components/all-info'
import { info, allColumn, common, staff_info, NetPay } from './column.js'
import ExportExcelDialog from '@/components/ExportExcelDialog'
import { mapState } from 'vuex'

export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: { allTable, Pagination, [ExportExcelDialog.name]: ExportExcelDialog },
  data() {
    return {
      projectId: this.$route.params.id,
      subProjectInfo: {},
      checkedColumn: allColumn,
      isIndeterminate: false,
      checkAll: true,
      columnInfo: info,
      currentColumn: [], // 表头
      tableData: {},
      requestParams: {
        // 请求参数
        page_size: 20,
        page: 1,
        search_word: '',
        data_type: 'all' // tabs栏控制
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0,
        currentPage: 1
      },
      tableCloumns: []
    }
  },
  computed: {
    ...mapState({
      // 货币
      currency: state => state.user.company_info.currency
    })
  },
  filters: {
    ThousandSeparator(input) {
      return input && input.toString().replace(/(^|\s)\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    }
  },
  created() {
    this.init()
  },
  watch: {
    currentColumn: {
      handler(v) {
        // this.activeData.info.settlement_type 1月结 2日结 3其他 99其他
        this.tableCloumns = v.filter(item =>
          item.isShow ? item.isShow.includes(Number(this.activeData.info.settlement_type)) : true
        )
      },
      deep: true,
      immediate: true
    },
    'activeData.state': {
      handler(v) {
        if (v === 3) {
          this.payrollSubStaffList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init() {
      this.loadSubStaffColumns()
      this.payrollSubStaffList() // 获取表格列表信息
    },
    get_income_type_column() {
      const res = []
      if (+this.activeData?.info.tax_deduction_status === 4) {
        res.push({
          label: this.$t('1980'),
          prop: 'income_type',
          // 1月结 2日结
          isShow: [1, 2],
          align: 'left',
          width: '200px'
        })
      }
      return res
    },
    loadSubStaffColumns() {
      this.currentColumn = []
      const query = this.checkAll ? ['all'] : this.checkedColumn
      if (!this.isIndeterminate && !this.checkAll) {
        this.currentColumn = [...common]
        this.currentColumn[0].width = 'auto'
        this.edit = false
        return
      }
      getListHeaderColumns({
        sub_project_id: this.projectId,
        data_type: query
      }).then(res => {
        this.currentColumn = []
        if (this.checkAll) {
          this.currentColumn = [...common, ...staff_info, ...this.get_income_type_column(), ...res.data, ...NetPay]
        } else {
          if (this.checkedColumn.includes('staff_info')) {
            this.currentColumn = [...common, ...staff_info, ...this.get_income_type_column(), ...res.data, ...NetPay]
          } else {
            this.currentColumn = [...common, ...res.data, ...NetPay]
          }
        }
        this.currentColumn[0].width = '264'
        this.edit = true
        if (this.currentColumn.length === 2) {
          this.currentColumn[0].width = 'auto'
        }
      })
    },
    async payrollSubStaffList() {
      // 请求列表数据
      const msg = {
        sort: this.sort, // 排序相关
        dir: this.dir,
        ...this.requestParams,
        sub_project_id: this.projectId
      }
      const res = await payrollSubStaffList(msg)
      const data = res.data
      this.tableData = res.data
      this.page.total = data.count
    },
    handlerSort({ prop, order }) {
      // 排序
      this.sort = prop
      this.dir = order
      this.payrollSubStaffList()
    },
    handleCheckAllChange(val) {
      // 全量信息
      this.checkedColumn = val ? allColumn : []
      this.isIndeterminate = false
      this.loadSubStaffColumns()
    },
    handleCheckedCitiesChange(value) {
      // 选择展示表格内容
      const checkedCount = value.length
      const len = Object.keys(this.columnInfo).length
      this.checkAll = checkedCount === len
      this.isIndeterminate = checkedCount > 0 && checkedCount < len
      this.loadSubStaffColumns()
    },
    handleReset() {
      // 重置
      this.checkedColumn = []
      this.handleCheckedCitiesChange(this.checkedColumn)
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.payrollSubStaffList()
    },
    handleSizeChange(val) {
      this.requestParams.page = 1
      this.requestParams.page_size = val
      this.payrollSubStaffList()
    },
    handleExport() {
      const params = { relation_type: 3, relation_id: this.projectId }
      const data = { sub_project_id: this.projectId }
      this.$refs.ExportExcelDialog.init(params, data)
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  border-bottom: 1px solid #f0f0f0;
  padding: 40px 0 28px;
  text-align: center;
  .el-icon-success {
    font-size: 70px;
    color: #52c41a;
  }
  .el-icon-error {
    font-size: 70px;
    color: #f56c6c;
  }
  .icon {
    width: 72px;
    height: 72px;
  }
  .icon-wraing {
    line-height: 72px;
    border-radius: 50%;
    background: #fa8a14;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    .sp {
      width: 24px;
      height: 24px;
      clear: both;
      margin: 0 auto;
    }
    .sp-3balls,
    .sp-3balls:before,
    .sp-3balls:after {
      border-radius: 50%;
      background-color: #fff;
      width: 10px;
      height: 10px;
      transform-origin: center center;
      display: inline-block;
    }
    .sp-3balls {
      position: relative;
      background: rgba(225, 225, 225, 1);
      animation: spScaleAlpha 1s infinite linear;
    }
    .sp-3balls::before,
    .sp-3balls::after {
      content: '';
      position: absolute;
      opacity: 0.25;
    }
    .sp-3balls:before {
      left: 18px;
      top: 0px;
      animation: spScaleAlphaBefore 1s infinite linear;
    }
    .sp-3balls::after {
      left: -18px;
      top: 0px;
      animation: spScaleAlphaAfter 1s infinite linear;
    }
  }
  h2 {
    font-size: 24px;
    color: #262626;
    margin: 16px 0;
  }
  p {
    font-size: 14px;
    color: #909399;
  }
  &-con {
    padding-top: 8px;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    .info-con-item {
      background: #f6f7f8;
      border-radius: 4px;
      height: 118px;
      min-width: 360px;
      max-width: 33.33%;
      flex: 1;
      text-align: center;
      padding: 24px 0;
      margin: 0 8px 20px;
      margin-bottom: 20px;
      p {
        font-size: 18px;
        color: #595959;
        padding-bottom: 12px;
      }
      span {
        font-size: 36px;
        color: #262626;
        font-weight: 600;
      }
    }
  }
}

.content {
  padding-top: 24px;
  padding-bottom: 15px;
  h1 {
    margin: 0;
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    span {
      font-size: 16px;
      color: #262626;
    }
    .some {
      img {
        width: 32px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
  .search {
    display: flex;
    flex-wrap: wrap;
    .search-center {
      flex: 1;
    }
    .search-left {
      padding-bottom: 16px;
      .screen {
        /deep/ span {
          display: flex;
          align-items: center;
        }
        img {
          width: 16px;
          margin-left: 4px;
        }
      }
    }
    .search-right {
      padding-bottom: 16px;
      .some {
        img {
          width: 32px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .el-button {
        margin-left: 16px;
      }
    }
    .search-input {
      min-width: 320px;
      margin: 0 16px;
    }
  }
}
.some-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-checkbox {
    display: block;
  }
  padding-bottom: 13px;
  border-bottom: 1px solid #f0f0f0;
}
.column-checkbox {
  padding-left: 3px;
  display: block;
  height: 34px;
  line-height: 34px;
}
@keyframes spScaleAlpha {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.25;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes spScaleAlphaBefore {
  0% {
    opacity: 0.25;
  }
  33% {
    opacity: 1;
  }
  66% {
    opacity: 0.25;
  }
}
@keyframes spScaleAlphaAfter {
  33% {
    opacity: 0.25;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
